package com.example.mystybag.login.model

import com.example.mystybag.core.model.CityItem
import com.example.mystybag.core.model.CountryItem

enum class CompanyContactRequiredField {
    LEGAL_ENTITY_NAME,
    COUNTRY,
    CITY,
    ADDRESS,
    DIAL_CODE,
    PHONE_NUMBER,
    SMS_CODE
}

data class MerchantRegistrationAddCompanyContactUIState(
    val legalEntityName: String = "",
    val registeredCompanyStreet: String = "",
    val registeredCompanyCountryId: Int? = null,
    val registeredCompanyCountryName: String = "",
    val registeredCompanyCityId: Long? = null,
    val registeredCompanyCityName: String = "",
    val companyPhoneNumber: String = "",
    val companyDialCode: String = "",
    val cities: List<CityItem> = emptyList(),
    val countries: List<CountryItem> = emptyList(),
    val showCityPicker: Boolean = false,
    val showCountryPicker: Boolean = false,
    val showCompanyPhoneCountryPicker: Boolean = false,
    val privacyPolicyAccepted: Boolean = false,
    val isLoading: Boolean = false,
    val awaitingSmsVerification: Boolean = false,
    val smsVerificationCode: String = "",
    /** >0 while resend is disabled and countdown is shown; 0 means resend allowed. */
    val smsResendCooldownSeconds: Int = 0,
    val requiredFieldErrors: Set<CompanyContactRequiredField> = emptySet(),
    /** Incremented when validation runs so the UI can react (e.g. scroll). */
    val validationRequestId: Int = 0
)
